import { render, staticRenderFns } from "./NotificationOptions.vue?vue&type=template&id=b3bd3194&"
import script from "./NotificationOptions.vue?vue&type=script&lang=js&"
export * from "./NotificationOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports